import { EditingState, state as defaultState } from '@/store/modules/editing/state';
import { getters } from '@/store/modules/editing/getters';
import { mutations } from '@/store/modules/editing/mutations';
import { actions } from '@/store/modules/editing/actions';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<EditingState, RootState>;
